import React, { useState, useEffect,  useContext } from 'react';
import './LongestResponse.css';
import DropDown from '../DropDown/DropDown';
import { CardLongestResponseContext } from '../../contexts/CardLongestResponseContext';
import logComponent from '../../common/logComponent';



export default function LongestResponseTimeRange({ updateTimeRange }) {
  const cardLongestResponseContext = useContext(CardLongestResponseContext);
  const [currentTimeRange, setCurrentTimeRange] = useState(null);
  const { timeRanges } = cardLongestResponseContext;

  if (logComponent('LongestResponseTimeRange')) { console.debug('LongestResponseTimeRange rendered'); }

  useEffect(() => {
    if (logComponent('LongestResponseTimeRange')) {console.debug('LongestResponseTimeRange useEffect [cardLongestResponseContext.longestResponseTimeRange ]'); }
    setCurrentTimeRange(cardLongestResponseContext.longestResponseTimeRange);

  }, [cardLongestResponseContext.longestResponseTimeRange]);




  return (
    <DropDown className="Alarm-History__drop-down" items={timeRanges} selectedItem={currentTimeRange} onSelect={updateTimeRange} />
  );
}